<emperor-button [disabled]="buttonDisabled" [id]="buttonId" (click)="click()">{{ text }}</emperor-button>
